import { slate } from '@vimeo/iris/color';

export const breakpoints = {
  XLDesktop: '112.5em', // 1800px
  desktop: '68.75em', // 1100px
  tablet: '46.875em', // 750px
  mobile: '23.4375em', // 375px
  standardTablet: '48em', // 768px
};

export const time = {
  normal: '.2s',
};

export const colors = {
  astroGranite: slate(830),
  gray3: slate(380),
  white: '#fff',
};
